module.exports = __webpack_public_path__ + "static/media/promociones_ico.19fb87ed.svg";